// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"03346f77","879":"d380661f"}[chunkId] + ".chunk.js";
};